package com.tregz.tremenz.ui.theme

import androidx.compose.material3.Typography
import androidx.compose.runtime.Composable
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.sp
import org.jetbrains.compose.resources.Font
import tregz.tremenz.shared.generated.resources.Res
import tregz.tremenz.shared.generated.resources.oxanium_bold
import tregz.tremenz.shared.generated.resources.oxanium_medium
import tregz.tremenz.shared.generated.resources.oxanium_regular
import tregz.tremenz.shared.generated.resources.oxanium_semibold

val OxaniumFamily: FontFamily
    @Composable get() = FontFamily(
        Font(Res.font.oxanium_regular, FontWeight.Normal),
        Font(Res.font.oxanium_medium, FontWeight.Medium),
        Font(Res.font.oxanium_semibold, FontWeight.SemiBold),
        Font(Res.font.oxanium_bold, FontWeight.Bold)
    )

@Composable
fun tremenzTypography(): Typography {
    val oxanium = OxaniumFamily
    return Typography(
        headlineLarge = TextStyle(
            fontFamily = oxanium,
            fontWeight = FontWeight.Bold,
            fontSize = 32.sp,
            lineHeight = 40.sp,
            letterSpacing = 0.sp
        ),
        headlineMedium = TextStyle(
            fontFamily = oxanium,
            fontWeight = FontWeight.Bold,
            fontSize = 28.sp,
            lineHeight = 36.sp,
            letterSpacing = 0.sp
        ),
        headlineSmall = TextStyle(
            fontFamily = oxanium,
            fontWeight = FontWeight.SemiBold,
            fontSize = 24.sp,
            lineHeight = 32.sp,
            letterSpacing = 0.sp
        ),
        titleLarge = TextStyle(
            fontFamily = oxanium,
            fontWeight = FontWeight.Bold,
            fontSize = 22.sp,
            lineHeight = 28.sp,
            letterSpacing = 0.sp
        ),
        titleMedium = TextStyle(
            fontFamily = oxanium,
            fontWeight = FontWeight.SemiBold,
            fontSize = 18.sp,
            lineHeight = 24.sp,
            letterSpacing = 0.15.sp
        ),
        titleSmall = TextStyle(
            fontFamily = oxanium,
            fontWeight = FontWeight.Medium,
            fontSize = 14.sp,
            lineHeight = 20.sp,
            letterSpacing = 0.1.sp
        ),
        bodyLarge = TextStyle(
            fontFamily = FontFamily.Default,
            fontWeight = FontWeight.Normal,
            fontSize = 16.sp,
            lineHeight = 24.sp,
            letterSpacing = 0.5.sp
        )
    )
}